import { PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { LinkedRecord } from "../domain/LinkedRecord";
import { LinkedRecordCreate } from "../domain/LinkedRecordCreate";
import {
  LOADED_LINKEDRECORDS,
  LOADING_LINKEDRECORDS,
  WAIT_LINKED_RECORDS,
  CREATING_LINKED_RECORD,
  REMOVING_LINKED_RECORD,
} from "./constants";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const loadedLinkedRecords = (
  resourceId: string,
  response: PagedResponse<LinkedRecord>
) => ({
  type: LOADED_LINKEDRECORDS,
  payload: { resourceId, response },
});

export const loadingLinkedRecords = (
  resourceId: string,
  params: QueryParams = {}
) => ({
  type: LOADING_LINKEDRECORDS,
  payload: { resourceId, params },
});

export const waitLinkedRecords = (resourceId: string) => ({
  type: WAIT_LINKED_RECORDS,
  payload: { resourceId },
});

export const createLinkedRecord = (
  resourceId: string,
  linkedRecord: LinkedRecordCreate
) => ({
  type: CREATING_LINKED_RECORD,
  payload: { resourceId, linkedRecord },
});

export const removeLinkedRecord = (
  id: string,
  resourceId: string,
) => ({
  type: REMOVING_LINKED_RECORD,
  payload: { id, resourceId },
});